import loaded from '@/scripts/helpers/loaded';

const SPINNER = '<div class="lds-ring"><div></div><div></div><div></div><div></div></div>';

function firstMissingRequiredOption() {
    const fields = document.querySelectorAll(
        'input[data-required="1"]:not([disabled]), select[data-required="1"]:not([disabled])'
    );

    let firstError = null;

    fields.forEach((field) => {
        const container = field.closest('.tpo_option-container');
        if (container && container.classList.contains('tpo_hidden')) return;
        if (field.value?.trim()) return;

        if (!firstError) firstError = container;

        const msg = container?.querySelector('.tpo_error-message');
        if (msg) {
            msg.textContent = field.classList.contains('tpo_hidden-checkbox')
                ? 'Please select an option'
                : 'This field is required';
            msg.style.display = 'block';
        }
    });

    return firstError;
}

function onAddToCartClick(e) {
    const btn = e.target.closest('#AddToCartCustom, button.add-to-cart');
    if (!btn) return;

    if (btn.id === 'AddToCartCustom') {
        const firstError = firstMissingRequiredOption();
        if (firstError) {
            e.preventDefault();
            e.stopPropagation();
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }
    }

    if (!btn.querySelector('.lds-ring')) {
        btn.innerHTML = SPINNER;
    }
}

export default function initEasifyAddToCart() {
    loaded(() => document.addEventListener('click', onAddToCartClick, true));
}
